<template>
  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <div v-if="loading" class="spinner text-xs-center">
      <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
    </div>
    <div v-else-if="!hasCharge && !isEdit && !isShow" class="mt-4 mb-4 text-xs-center">
      {{ $t('No shipping option') }}
    </div>
    <div v-else>
      <div>
        <v-layout
          align-start
          justify-start
          row
          fill-height
          wrap
          style="align-items: stretch"
        ></v-layout>
        <template v-for="charge in charges">
          <shipping-detail-item
            :key="'shipping_' + charge.name"
            v-model="charge.value"
            :isShow="isShow"
            :name="charge.name"
            :charges="charges"
          ></shipping-detail-item>
        </template>
        <template v-if="additional_charge">
          <v-divider class="mb-3 mt-3" v-if="additional_charge.value[1] || isShow"></v-divider>
          <shipping-detail-item
            :key="'shipping_' + 'additionalproduct_charge'"
            v-model="additional_charge.value"
            :isShow="isShow"
            :name="'additionalproduct_charge'"
            :charges="charges"
          ></shipping-detail-item>
        </template>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import ShippingDetailItem from './ShippingDetailItem.vue'

export default {
  props: ['init', 'isShow'],
  inject: ['$validator'],
  data: function() {
    return {
      loading: true,
      charges: [],
      additional_charge: null
    }
  },
  components: {
    ShippingDetailItem
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    hasCharge: function() {
      var vm = this
      let charges = vm.charges.filter(el => {
        if (el.value.length > 0 && el.value[1]) {
          return true
        } else if (el.value.length == 1) {
          return true
        }
        return false
      })

      return charges.length > 0
    }
  },
  created() {
    var vm = this
  },
  async mounted() {
    var vm = this
    vm.loading = true
    try {
      await vm.getAllShipingCharge()

      vm.cached_charges = JSON.stringify(vm.charges)
      vm.loading = false
    } catch (error) {}
  },
  methods: {
    getAllShipingCharge: function() {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getAllShipingCharge({ pageid: vm.selectedBot.pageid }, function(error, response) {
          if (error) {
            reject(error)
          }
          let charges = Object.entries(response.shippinglist)

          charges = charges.map(el => {
            return {
              name: el[0],
              value: el[1]
            }
          })
          charges = charges.sort((a, b) => {
            if (a.name.includes('other')) {
              return 2
            } else if (b.name.includes('other')) {
              return -2
            }
            if (a.name.includes('cod_')) {
              return 1
            } else if (b.name.includes('cod_')) {
              return -1
            }
            if (a.name == b.name) {
              return 0
            } else {
              return a.name > b.name ? 1 : -1
            }
          })

          let additional_charge_index = charges.findIndex(
            el => el.name == 'additionalproduct_charge'
          )
          vm.additional_charge = charges[additional_charge_index]
          if (additional_charge_index != -1) charges.splice(additional_charge_index, 1)
          vm.charges = charges
          resolve()
        })
      })
    }
  },
  watch: {}
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/setting/ecommerce/ShippingDetail.vue